import { tracking } from '@iwoca/frontend-tracking-library';
import { fetchGetCompanySearch } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { TGetCompanySearchResponseDE } from '../../lapiOverrideTypesDE';

export function useGetCompanySearch({
  searchQuery,
  enabled,
}: {
  searchQuery: string;
  enabled?: boolean;
}) {
  return useQuery({
    queryKey: ['companySearch', searchQuery],
    queryFn: async () => {
      tracking.ampli.companySearchUsed({
        query_length: searchQuery.length,
      });

      return await fetchGetCompanySearch({
        // @ts-expect-error LAPI client uses UK typing, overriding to DE
        query: { phrase: searchQuery },
      });
    },
    // @ts-expect-error LAPI client uses UK typing, overriding to DE
    select: (data) => data as TGetCompanySearchResponseDE,
    enabled: !!searchQuery && enabled,
  });
}
